import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth, API } from "../App";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle, XCircle, Loader2, ArrowLeft } from "lucide-react";
import axios from "axios";

export const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    const checkStatus = async () => {
      try {
        const res = await axios.get(`${API}/checkout/status/${sessionId}`, { withCredentials: true });
        setDetails(res.data);
        setStatus(res.data.payment_status === "paid" ? "success" : "pending");
        if (res.data.payment_status === "paid") await checkAuth();
      } catch {
        setStatus("error");
      }
    };
    checkStatus();
  }, [searchParams, checkAuth]);

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex items-center justify-center p-4">
      <Card className="max-w-md w-full" data-testid="payment-success-card">
        <CardContent className="pt-8 pb-6 text-center">
          {status === "loading" && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-[#6697a4] mx-auto mb-4" />
              <h2 className="text-xl font-bold text-[#3d5a63] mb-2">A verificar pagamento...</h2>
            </>
          )}
          {status === "success" && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="h-8 w-8 text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-[#3d5a63] mb-2">Pagamento confirmado!</h2>
              <p className="text-[#94A3B8] mb-1">{details?.pack_name}</p>
              <p className="text-2xl font-bold text-[#6697a4] mb-4">+{details?.credits} crédito{details?.credits > 1 ? 's' : ''}</p>
              <p className="text-sm text-[#94A3B8] mb-6">
                {details?.pack_type === "private" ? "Aulas privadas" : "Aulas de grupo"}
              </p>
              <Button onClick={() => navigate("/dashboard")} className="w-full bg-[#6697a4] hover:bg-[#3d5a63]" data-testid="go-dashboard-btn">
                Ir para o Dashboard
              </Button>
            </>
          )}
          {status === "pending" && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-yellow-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold text-[#3d5a63] mb-2">Pagamento pendente</h2>
              <p className="text-[#94A3B8] mb-6">O teu pagamento está a ser processado. Os créditos serão adicionados automaticamente.</p>
              <Button onClick={() => navigate("/dashboard")} variant="outline" className="w-full">Voltar ao Dashboard</Button>
            </>
          )}
          {status === "error" && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="h-8 w-8 text-red-600" />
              </div>
              <h2 className="text-xl font-bold text-[#3d5a63] mb-2">Erro no pagamento</h2>
              <p className="text-[#94A3B8] mb-6">Não foi possível verificar o pagamento. Contacta-nos se o problema persistir.</p>
              <Button onClick={() => navigate("/dashboard")} variant="outline" className="w-full">Voltar ao Dashboard</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#f5f5f5] flex items-center justify-center p-4">
      <Card className="max-w-md w-full" data-testid="payment-cancel-card">
        <CardContent className="pt-8 pb-6 text-center">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <ArrowLeft className="h-8 w-8 text-slate-500" />
          </div>
          <h2 className="text-xl font-bold text-[#3d5a63] mb-2">Pagamento cancelado</h2>
          <p className="text-[#94A3B8] mb-6">Não foi feita nenhuma cobrança. Podes tentar novamente quando quiseres.</p>
          <div className="space-y-2">
            <Button onClick={() => navigate("/dashboard")} className="w-full bg-[#6697a4] hover:bg-[#3d5a63]">Voltar ao Dashboard</Button>
            <Button onClick={() => navigate("/packs")} variant="outline" className="w-full">Ver Packs</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
